export const ADD_TO_CART = 'addToCart/add_to_cart';
export const INCREMENT = 'addToCart/increment';
export const DECREMENT = 'addToCart/decrement';